import React from "react";
import {ProgressBar} from "react-bootstrap";
import classNames from 'classnames';

import '../../../assets/sass/components/progress_bars/circular-label-progress-bar.scss';

const CircularLabelProgressBar = props => {
    const {now, color} = props;

    const label = (<div className="circular-label-progress-bar--label"><span className="text"> {now}</span></div>);
    return (
        <ProgressBar className={classNames("circular-label-progress-bar", color)} now={now} label={label}/>
    );
};

export default CircularLabelProgressBar;
